import React from 'react';

import Table from 'components/new_ui/Table';
import usePayment from 'components/Common/Affiliates/Hooks/usePayments';
import columns from './columns';
import NoData from './NoData';

export default function Payments() {
  const { payments } = usePayment();

  return (
    <Table
      columns={columns}
      data={payments || []}
      loading={payments == null}
      noData={<NoData />}
      selectableRows={false}
    />
  );
}
